export default __webpack_public_path__ + "static/media/37.94a0b5ca.png";